import { useMemo } from 'react'

const Pagination = ({ total, perPage, page, onButtonClick }) => {

    const handleButtonClick = (element) => {

        switch ( element.target.value ) {
            case 'prev':
                onButtonClick(page - 1)
                break;
            case 'next':
                onButtonClick(page + 1)
                break;
            default:
                onButtonClick( parseInt(element.target.value) )
        }

    }

    const pageCount = useMemo(() => Math.ceil(total / perPage), [total, perPage])

    const pageButtons = useMemo(() => {
        const buttons = []
        for (let i = 1; i <= pageCount; i++) {
            buttons.push(
                <li key={i} className={ page === i ? 'page-item active' : 'page-item' }>
                    <button aria-label="page-number-button" className="page-link" onClick={ handleButtonClick } value={ i }>{ i }</button>
                </li>
            )
        }
        return buttons
    }, [pageCount, page])

    return (
        <ul className="pagination">
            <li className={ page <= 1 ? 'page-item disabled' : 'page-item' } data-disabled={ page <= 1 ? 'true' : 'false' }>
                <button aria-label="previous-page-button" className="page-link" onClick={ page > 1 ? handleButtonClick : undefined } value="prev">
                    <i className="fal fa-angle-left"></i>
                </button>
            </li>
            { pageButtons }
            <li className={ page >= pageCount ? 'page-item disabled' : 'page-item' } data-disabled={ page >= pageCount ? 'true' : 'false' }>
                <button aria-label="next-page-button" className="page-link" onClick={ page < pageCount ? handleButtonClick : undefined } value="next">
                    <i className="fal fa-angle-right"></i>
                </button>
            </li>
        </ul>
    )

}

export default Pagination